import styled from 'styled-components';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

export const AgentWizardOptionButton = styled.button<{ $selected?: boolean }>`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 48px;
  padding: ${themeSpacing.xs1} ${themeSpacing.xs3};

  background: ${themeColors.background};
  border: 1px solid
    ${({ $selected }) => ($selected ? themeColors.textPrimary : themeColors.borderSubtle)};
  border-radius: ${themeSpacing.xs3};

  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    background: ${themeColors.backgroundHover};
    border-color: ${({ $selected }) => ($selected ? themeColors.textPrimary : themeColors.borderStrong)};
  }
`;
